import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import Box from '@material-ui/core/Box';
import Container from '@material-ui/core/Container';

import Header from '../Header';
import Subheader from '../Subheader';
import Footer from '../Footer';

import useWindowDimensions from 'helpers/hooks/useWindowDimensions';

import { useStyles } from './styles';

const Layout = ({ children, ...props }) => {
  const classes = useStyles();

  const history = useHistory();
  const isScheduling = history.location.pathname == '/agendamento';

  const { width } = useWindowDimensions();
  const isSchedulingSm = width < 1150;

  const { isMapSelected } = useSelector(state => state.scheduling);

  return(
    <Box className={classes.root}>
      <Header />
      {!(isScheduling && isSchedulingSm && isMapSelected) && (
        <Subheader {...props} />
      )}
      <Container
        maxWidth={isScheduling ? false : "lg"}
        className={(isScheduling && isSchedulingSm) ? classes.schedulingContainer : classes.container}
      >
        {children}
      </Container>
      {!isScheduling && (
        <Footer />
      )}
    </Box>
  );
}

Layout.propTypes = {
  children: PropTypes.node.isRequired
};

export default Layout;